import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const language = typeof localStorage !== 'undefined' ? localStorage.getItem('language') : 'en';

// English translations
export const enTranslations = {
  adminPortal: 'Primedocs Admin DEMO',
  search: 'Search...',
  caseId: 'Case ID',
  caseStatus: 'Case Status',
  customerName: 'Customer Name',
  phoneNumber: 'Phone Number',
  documents: 'Documents',
  lastUpload: 'Last Upload',
  actions: 'Actions',
  view: 'View',
  documentProgress: '{{uploaded}}/{{required}}',
  documentDetails: 'Document Details for Case {{caseId}}',
  uploadedDocuments: 'Uploaded Documents',
  requiredDocuments: 'Required Documents',
  optionalDocuments: 'Optional Documents',
  noDocuments: 'No documents uploaded yet',
  uploadedOn: 'Uploaded on',
  backToDashboard: 'Back to Dashboard',
  darkMode: 'Dark Mode',
  lightMode: 'Light Mode',
  language: 'Change Language',
  english: 'English',
  spanish: 'Spanish',
  chinese: 'Chinese',
  settings: 'Settings',
  appearance: 'Appearance',
  about: 'About',
  version: 'Version',
  buildDate: 'Build Date',
  saveAndClose: 'Save and Close',
  fontSize: 'Font Size',
  theme: 'Theme',
  light: 'Light',
  dark: 'Dark',
  auto: 'Auto',
  autoMode: 'Auto Mode',
  dataSource: 'Data Source',
  useDynamoDB: 'Use AWS DynamoDB',
  usingDynamoDB: 'Currently loading data from AWS DynamoDB',
  usingLocalStorage: 'Currently using local storage data',
  awsRegion: 'AWS Region',
  tableName: 'DynamoDB Table Name',
  loadingData: 'Loading data...',
  errorLoadingData: 'Error loading data. Using local data instead.',
  requestSupport: 'Request Support',
  allRightsReserved: 'All rights reserved.',
  download: 'Download',
  downloadingFile: 'Downloading...',
  requiredDocument: 'Required',
  optionalDocument: 'Optional',
  // Previously added missing translations
  caseNotFound: 'Case not found',
  caseIdNotExist: 'The case ID you\'re looking for doesn\'t exist.',
  noRequiredDocuments: 'No required documents for this case.',
  noOptionalDocuments: 'No optional documents for this case.',
  complete: 'Complete',
  provided: 'Provided',
  required: 'Required',
  systemPreferenceDark: 'Using dark theme based on system preference',
  systemPreferenceLight: 'Using light theme based on system preference',
  
  // Basic nav
  requestdashboard: 'Request Dashboard',


  // Template Management
  documentTemplates: 'Request Document Templates',
  templateManagement: 'Request Template Management',
  noTemplatesFound: 'No templates found',
  newRequestTemplate: 'New Request Template',



  requestTemplates: 'Request Templates',
  createFirstTemplate: 'Create your first template',
  createTemplate: 'Create Template',
  assignTemplates: 'Assign Templates',
  back: 'Back',
  chooseTemplateToPreview: 'Choose a template to preview its contents',
  
  // My Templates
  myTemplates: 'My Templates',
  myTemplatesDescription: 'View and manage your saved document request templates',
  createNewTemplate: 'Create New Template',
  noTemplatesYet: 'No Templates Yet',
  noTemplatesYetDescription: 'Create your first template to get started',
  confirmDeleteTemplate: 'Are you sure you want to delete this template?',
  deleteTemplate: 'Delete Template',
  send: 'Send',
  yourSavedTemplates: 'Your saved custom templates',
  starterTemplates: 'Starter Templates',
  noSavedTemplates: 'No saved templates yet',
  
  // Recent Activity
  recentActivity: 'Recent Activity',
  recentActivityDescription: 'View recently sent document requests and their status',
  noActivityYet: 'No Activity Yet',
  noActivityYetDescription: 'Sent document requests will appear here',
  template: 'Template',
  recipient: 'Recipient',
  sentBy: 'Sent By',
  sentDate: 'Sent',
  statusSent: 'Sent',
  statusViewed: 'Viewed',
  statusCompleted: 'Completed',
  minutesAgo: 'minutes ago',
  hoursAgo: 'hours ago',
  daysAgo: 'days ago',
  documentReminder: 'Document Reminder',
  unknown: 'Unknown',
  mobileMenu: 'Mobile Menu',
  exportBackup: 'Export Backup',

  // Requests
  openNewRequest: 'Open New Request',


  // User Dropdown
  signedInAs: 'Signed in as',
  signOut: 'Sign Out',


  // unauthorized
  unauthorized: 'Unauthorized',
  unauthorizedMessage: 'You do not have permission to access this page. If you believe this is an error, please contact your administrator or file a support request using the link below.',

  // login page
  loginTitle: 'PrimeDocs Admin Portal DEMO',
  loginSubtitle: 'Welcome back, please login.',
  username: 'Username',
  password: 'Password',
  signIn: 'Sign In',
  msftadssoBtnText: 'Sign in with Active Directory',
  googleSignIn: 'Sign in with Google',
  regularUser: 'Regular User Demo',
  superUser: 'Super User Demo (Extra permissions)',
  loginwithdemoaccounts: 'Login with Demo Accounts',
  invalidLoginCredentials: 'Invalid login credentials',

  // login errors
  loginError: 'There was an error logging in. Please try again.',

  // Footer
  currentDate: 'Date',
  suggestAFeatureBtnText: 'Suggest a Feature',

  // Document type names - Required
  docIdCard: 'ID Card',
  docProofOfAddress: 'Proof of Address',
  docIncomeStatement: 'Income Statement',
  docTaxReturn: 'Tax Return',
  docBankStatement: 'Bank Statement',
  
  // Document type names - Optional
  docInsuranceInfo: 'Insurance Information',
  docReferenceLetters: 'Reference Letters',
  docAdditionalSupporting: 'Additional Supporting Documents',
  
  // Document descriptions - Required
  descIdCard: 'Government-issued photo identification',
  descProofOfAddress: 'Utility bill or bank statement showing current address',
  descIncomeStatement: 'Recent pay stubs or income verification',
  descTaxReturn: 'Most recent tax return document',
  descBankStatement: 'Last 3 months of bank statements',
  
  // Document descriptions - Optional
  descInsuranceInfo: 'Current insurance policy documents',
  descReferenceLetters: 'Personal or professional references',
  descAdditionalSupporting: 'Any other relevant documentation',

  // Reminder feature translations
  sendReminderEmailBtnText: 'Send Reminder',
  sendingReminder: 'Sending...',
  reminderSent: 'Reminder email sent',
  reminderCooldown: 'Already sent on {{date}}',
  lastReminderSent: 'Last reminder sent {{timeAgo}}',
  remindersUnavailable: 'All documents submitted',
  documentReminderH3Text: 'Document Reminders',
  reminderSuccess: 'Reminder email sent successfully',
  missingDocuments: 'Missing Documents',

  // Request Template Modal
  selectTemplateCategory: 'Select a Category',
  selectCategoryDescription: 'Choose a category to see available document templates',
  templatesAvailable: 'templates available',
  startFromScratch: 'Start from Scratch',
  selectTemplate: 'Select a Template',
  selectTemplateToPreview: 'Choose a template to preview its contents',
  templatePreview: 'Template Preview',
  includedDocuments: 'Included Documents',
  useThisTemplate: 'Use This Template',
  createNewRequestTemplate: 'Create New Request Template',
  createTemplateDescription: 'Choose from our starter templates or create your own custom document request template',
  chooseStarterTemplate: 'Choose a Starter Template',
  chooseStarterTemplateDesc: 'Select from pre-built templates for common use cases',
  customizeTemplate: 'Customize Your Template',
  customizeTemplateDesc: 'Add, remove, or modify document requirements to fit your needs',
  saveAndUse: 'Save and Use',
  saveAndUseDesc: 'Save your template and start using it for document requests',
  getStarted: 'Get Started',

  // Template Management additions
  searchTemplates: 'Search templates...',
  noTemplatesMatchingSearch: 'No templates match your search',
  noTemplatesCreated: 'No templates have been created yet',
  templateName: 'Template Name',
  lastUpdated: 'Last Updated',
  edit: 'Edit',
  delete: 'Delete',
  confirmDelete: 'Confirm Delete',
  deleteTemplateWarning: 'Are you sure you want to delete this template? This action cannot be undone.',
  loadingTemplates: 'Loading templates...',

  // Send Document Request
  sendDocumentRequest: 'Send Document Request',
  sendRequestDescription: 'Enter customer email addresses to send this document request',
  documentsToRequest: 'Documents to Request',
  recipientEmails: 'Recipient Email Addresses',
  addRecipientEmail: 'Add recipient email',
  enterEmailAddress: 'Enter email address',
  add: 'Add',
  emailRequired: 'Email address is required',
  invalidEmail: 'Please enter a valid email address',
  emailAlreadyAdded: 'This email has already been added',
  noRecipientsAdded: 'Please add at least one recipient',
  recipients: 'Recipients',
  sendRequest: 'Send Request',
  sendingRequest: 'Sending Request...',
  requestSentSuccessfully: 'Request Sent Successfully!',
  requestSentToRecipients: 'Document request has been sent to {{count}} recipient(s)',
  backToTemplates: 'Back to Templates',
  cancel: 'Cancel',
  
  // Template Editor (additional keys)
  editTemplate: 'Edit Template',
  createCustomTemplate: 'Create Custom Template',
  customTemplateDescription: 'Create your own custom document request template',
  templateInformation: 'Template Information',
  templateNameRequired: 'Template name is required',
  atLeastOneDocumentRequired: 'Please add at least one document to the template',
  allDocumentsMustHaveName: 'All documents must have a name',
  enterTemplateName: 'Enter template name',
  enterTemplateDescription: 'Enter template description (optional)',
  documentItems: 'Document Items',
  addDocument: 'Add Document',
  noDocumentsAdded: 'No documents added yet. Click "Add Document" to get started.',
  documentName: 'Document name',
  documentDescription: 'Description (optional)',
  saveAndContinue: 'Save and Continue'
};

// Spanish translations
export const esTranslations = {
  adminPortal: 'Admin de Primedocs DEMO',
  search: 'Buscar...',
  caseId: 'ID de Caso',
  caseStatus: 'Estado del Caso',
  customerName: 'Nombre del Cliente',
  phoneNumber: 'Número de Teléfono',
  documents: 'Documentos',
  lastUpload: 'Última Carga',
  actions: 'Acciones',
  view: 'Ver',
  documentProgress: '{{uploaded}}/{{required}}',
  documentDetails: 'Detalles de Documentos para Caso {{caseId}}',
  uploadedDocuments: 'Documentos Cargados',
  requiredDocuments: 'Documentos Requeridos',
  optionalDocuments: 'Documentos Opcionales',
  noDocuments: 'Aún no se han cargado documentos',
  uploadedOn: 'Cargado el',
  backToDashboard: 'Volver al Panel',
  darkMode: 'Modo Oscuro',
  lightMode: 'Modo Claro',
  language: 'Cambiar Idioma',
  english: 'Inglés',
  spanish: 'Español',
  chinese: 'Chino',
  settings: 'Configuración',
  appearance: 'Apariencia',
  about: 'Acerca de',
  version: 'Versión',
  buildDate: 'Fecha de compilación',
  saveAndClose: 'Guardar y Cerrar',
  fontSize: 'Tamaño de Fuente',
  theme: 'Tema',
  light: 'Claro',
  dark: 'Oscuro',
  auto: 'Auto',
  autoMode: 'Modo Automático',
  dataSource: 'Fuente de Datos',
  useDynamoDB: 'Usar AWS DynamoDB',
  usingDynamoDB: 'Actualmente cargando datos desde AWS DynamoDB',
  usingLocalStorage: 'Actualmente usando datos de almacenamiento local',
  awsRegion: 'Región de AWS',
  tableName: 'Nombre de la Tabla DynamoDB',
  loadingData: 'Cargando datos...',
  errorLoadingData: 'Error al cargar datos. Usando datos locales en su lugar.',
  requestSupport: 'Solicitar Soporte',
  allRightsReserved: 'Todos los derechos reservados.',
  download: 'Descargar',
  downloadingFile: 'Descargando...',
  requiredDocument: 'Requerido',
  optionalDocument: 'Opcional',
  // Previously added missing translations
  caseNotFound: 'Caso no encontrado',
  caseIdNotExist: 'El ID de caso que buscas no existe.',
  noRequiredDocuments: 'No hay documentos requeridos para este caso.',
  noOptionalDocuments: 'No hay documentos opcionales para este caso.',
  complete: 'Completo',
  provided: 'Proporcionado',
  required: 'Requerido',
  systemPreferenceDark: 'Usando tema oscuro según preferencia del sistema',
  systemPreferenceLight: 'Usando tema claro según preferencia del sistema',
  

  // login page
  loginTitle: 'Portal de Administración de Documentos',
  loginSubtitle: 'Bienvenido de nuevo, por favor inicia sesión.',
  username: 'Nombre de Usuario',
  password: 'Contraseña',
  signIn: 'Iniciar Sesión',
  msftadssoBtnText: 'Iniciar sesión con Active Directory',
  googleSignIn: 'Iniciar sesión con Google',
  regularUser: 'Usuario Regular Demo',
  superUser: 'Super Usuario Demo',
  loginwithdemoaccounts: 'Iniciar sesión con cuentas de demostración',
  invalidLoginCredentials: 'Credenciales de inicio de sesión inválidas',


  // Document type names - Required
  docIdCard: 'Tarjeta de Identificación',
  docProofOfAddress: 'Comprobante de Domicilio',
  docIncomeStatement: 'Comprobante de Ingresos',
  docTaxReturn: 'Declaración de Impuestos',
  docBankStatement: 'Estado de Cuenta Bancario',
  
  // Document type names - Optional
  docInsuranceInfo: 'Información de Seguro',
  docReferenceLetters: 'Cartas de Referencia',
  docAdditionalSupporting: 'Documentos Adicionales de Respaldo',
  
  // Document descriptions - Required
  descIdCard: 'Identificación con foto emitida por el gobierno',
  descProofOfAddress: 'Factura de servicios o estado de cuenta bancario que muestre la dirección actual',
  descIncomeStatement: 'Recibos de pago recientes o verificación de ingresos',
  descTaxReturn: 'Documento de declaración de impuestos más reciente',
  descBankStatement: 'Estados de cuenta bancarios de los últimos 3 meses',
  
  // Document descriptions - Optional
  descInsuranceInfo: 'Documentos de póliza de seguro actual',
  descReferenceLetters: 'Referencias personales o profesionales',
  descAdditionalSupporting: 'Cualquier otra documentación relevante',

  // Reminder feature translations
  sendReminderEmail: 'Enviar Correo de Recordatorio',
  sendingReminder: 'Enviando...',
  reminderSent: 'Recordatorio enviado',
  reminderCooldown: 'Ya enviado el {{date}}',
  lastReminderSent: 'Último recordatorio enviado {{timeAgo}}',
  remindersUnavailable: 'Todos los documentos enviados',
  documentReminders: 'Recordatorios de Documentos',
  reminderSuccess: 'Correo de recordatorio enviado con éxito',
  missingDocuments: 'Documentos Faltantes',

  // Request Template Modal
  selectTemplateCategory: 'Seleccionar una Categoría',
  selectCategoryDescription: 'Elige una categoría para ver las plantillas de documentos disponibles',
  templatesAvailable: 'plantillas disponibles',
  startFromScratch: 'Empezar desde Cero',
  selectTemplate: 'Seleccionar una Plantilla',
  selectTemplateToPreview: 'Elige una plantilla para ver su contenido',
  templatePreview: 'Vista Previa de Plantilla',
  includedDocuments: 'Documentos Incluidos',
  useThisTemplate: 'Usar Esta Plantilla',
  createNewRequestTemplate: 'Crear Nueva Plantilla de Solicitud',
  createTemplateDescription: 'Elige de nuestras plantillas iniciales o crea tu propia plantilla de solicitud de documentos personalizada',
  chooseStarterTemplate: 'Elegir una Plantilla Inicial',
  chooseStarterTemplateDesc: 'Selecciona de plantillas preconstruidas para casos de uso comunes',
  customizeTemplate: 'Personalizar tu Plantilla',
  customizeTemplateDesc: 'Añadir, eliminar o modificar requisitos de documentos según tus necesidades',
  saveAndUse: 'Guardar y Usar',
  saveAndUseDesc: 'Guarda tu plantilla y comienza a usarla para solicitudes de documentos',
  getStarted: 'Comenzar',

  // Template Management additions
  searchTemplates: 'Buscar plantillas...',
  noTemplatesMatchingSearch: 'No hay plantillas que coincidan con tu búsqueda',
  noTemplatesCreated: 'Aún no se han creado plantillas',
  templateName: 'Nombre de Plantilla',
  lastUpdated: 'Última Actualización',
  edit: 'Editar',
  delete: 'Eliminar',
  confirmDelete: 'Confirmar Eliminación',
  deleteTemplateWarning: '¿Estás seguro de que quieres eliminar esta plantilla? Esta acción no se puede deshacer.',
  loadingTemplates: 'Cargando plantillas...',

  // Send Document Request
  sendDocumentRequest: 'Enviar Solicitud de Documentos',
  sendRequestDescription: 'Ingrese las direcciones de correo electrónico de los clientes para enviar esta solicitud de documentos',
  documentsToRequest: 'Documentos a Solicitar',
  recipientEmails: 'Direcciones de Correo Electrónico de Destinatarios',
  addRecipientEmail: 'Agregar correo electrónico de destinatario',
  enterEmailAddress: 'Ingrese dirección de correo electrónico',
  add: 'Agregar',
  emailRequired: 'La dirección de correo electrónico es requerida',
  invalidEmail: 'Por favor ingrese una dirección de correo electrónico válida',
  emailAlreadyAdded: 'Este correo electrónico ya ha sido agregado',
  noRecipientsAdded: 'Por favor agregue al menos un destinatario',
  recipients: 'Destinatarios',
  sendRequest: 'Enviar Solicitud',
  sendingRequest: 'Enviando Solicitud...',
  requestSentSuccessfully: '¡Solicitud Enviada Exitosamente!',
  requestSentToRecipients: 'La solicitud de documentos ha sido enviada a {{count}} destinatario(s)',
  backToTemplates: 'Volver a Plantillas',

  // Uncategorized
  dashboard: "Panel de control",
  signedInAs: "Conectado como",
  signOut: "Cerrar sesión",
  loginError: "Error de inicio de sesión",
  currentDate: "Fecha actual",
  suggestAFeatureBtnText: "Sugerir una función",

  requestdashboard: "Panel de Solicitudes",        
  documentTemplates: "Documentos de Template",       
  templateManagement: "Gestión de plantillas",      
  noTemplatesFound: "No se encontraron plantillas",        
  newRequestTemplate: "Nueva Plantilla de Solicitud",      
  requestTemplates: "Plantillas de Solicitud",        
  createFirstTemplate: "Crear tu primera plantilla",     
  createTemplate: "Crear Plantilla",
  assignTemplates: "Asignar Plantillas",
  back: 'Atrás',
  chooseTemplateToPreview: 'Elige una plantilla para previsualizar su contenido',
  
  // My Templates
  myTemplates: 'Mis Plantillas',
  myTemplatesDescription: 'Ver y gestionar tus plantillas de solicitud de documentos guardadas',
  createNewTemplate: 'Crear Nueva Plantilla',
  noTemplatesYet: 'Aún No Hay Plantillas',
  noTemplatesYetDescription: 'Crea tu primera plantilla para comenzar',
  confirmDeleteTemplate: '¿Estás seguro de que quieres eliminar esta plantilla?',
  deleteTemplate: 'Eliminar Plantilla',
  send: 'Enviar',
  yourSavedTemplates: 'Tus plantillas personalizadas guardadas',
  starterTemplates: 'Plantillas Iniciales',
  noSavedTemplates: 'Aún no hay plantillas guardadas',
  
  // Recent Activity
  recentActivity: 'Actividad Reciente',
  recentActivityDescription: 'Ver solicitudes de documentos enviadas recientemente y su estado',
  noActivityYet: 'Aún No Hay Actividad',
  noActivityYetDescription: 'Las solicitudes de documentos enviadas aparecerán aquí',
  template: 'Plantilla',
  recipient: 'Destinatario',
  sentBy: 'Enviado Por',
  sentDate: 'Enviado',
  statusSent: 'Enviado',
  statusViewed: 'Visto',
  statusCompleted: 'Completado',
  minutesAgo: 'minutos atrás',
  hoursAgo: 'horas atrás',
  daysAgo: 'días atrás',
  documentReminder: 'Recordatorio de Documentos',
  unknown: 'Desconocido',
  mobileMenu: 'Menú Móvil',
  exportBackup: 'Exportar Respaldo',
  
  openNewRequest: "Abrir nueva solicitud",
  unauthorized: "No autorizado",
  unauthorizedMessage: "No tienes permiso para acceder a esta página",     
  sendReminderEmailBtnText: "Enviar Recordatorio",
  documentReminderH3Text: "Recordatorios de Documentos",
  
  // Template Editor (additional keys)
  editTemplate: 'Editar Plantilla',
  createCustomTemplate: 'Crear Plantilla Personalizada',
  customTemplateDescription: 'Cree su propia plantilla de solicitud de documentos personalizada',
  templateInformation: 'Información de la Plantilla',
  templateNameRequired: 'El nombre de la plantilla es requerido',
  atLeastOneDocumentRequired: 'Por favor agregue al menos un documento a la plantilla',
  allDocumentsMustHaveName: 'Todos los documentos deben tener un nombre',
  enterTemplateName: 'Ingrese el nombre de la plantilla',
  enterTemplateDescription: 'Ingrese la descripción de la plantilla (opcional)',
  documentItems: 'Elementos del Documento',
  addDocument: 'Agregar Documento',
  noDocumentsAdded: 'No se han agregado documentos aún. Haga clic en "Agregar Documento" para comenzar.',
  documentName: 'Nombre del documento',
  documentDescription: 'Descripción (opcional)',
  saveAndContinue: 'Guardar y Continuar',
  cancel: "Cancelar"
};


// Chinese translations
export const zhTranslations = {
  adminPortal: 'PrimeDocs 管理 演示',
  search: '搜索...',
  caseId: '案例ID',
  caseStatus: '案例状态',
  customerName: '客户名称',
  phoneNumber: '电话号码',
  documents: '文档',
  lastUpload: '最后上传',
  actions: '操作',
  view: '查看',
  documentProgress: '{{uploaded}}/{{required}}',
  documentDetails: '案例 {{caseId}} 的文档详情',
  uploadedDocuments: '已上传文档',
  requiredDocuments: '必需文档',
  optionalDocuments: '可选文档',
  noDocuments: '尚未上传文档',
  uploadedOn: '上传于',
  backToDashboard: '返回仪表板',
  darkMode: '深色模式',
  lightMode: '浅色模式',
  language: '更换语言',
  english: '英语',
  spanish: '西班牙语',
  chinese: '中文',
  settings: '设置',
  appearance: '外观',
  about: '关于',
  version: '版本',
  buildDate: '构建日期',
  saveAndClose: '保存并关闭',
  fontSize: '字体大小',
  theme: '主题',
  light: '亮色',
  dark: '暗色',
  auto: '自动',
  autoMode: '自动模式',
  dataSource: '数据源',
  useDynamoDB: '使用AWS DynamoDB',
  usingDynamoDB: '当前从AWS DynamoDB加载数据',
  usingLocalStorage: '当前使用本地存储数据',
  awsRegion: 'AWS区域',
  tableName: 'DynamoDB表名',
  loadingData: '加载数据中...',
  errorLoadingData: '加载数据错误。改用本地数据。',
  requestSupport: '请求支持',
  allRightsReserved: '版权所有。',
  download: '下载',
  downloadingFile: '下载中...',
  requiredDocument: '必需',
  optionalDocument: '可选',
  // Previously added missing translations
  caseNotFound: '未找到案例',
  caseIdNotExist: '您查找的案例ID不存在。',
  noRequiredDocuments: '此案例没有必需文档。',
  noOptionalDocuments: '此案例没有可选文档。',
  complete: '完成',
  provided: '已提供',
  required: '必需',
  systemPreferenceDark: '根据系统偏好使用深色主题',
  systemPreferenceLight: '根据系统偏好使用浅色主题',
  
  // Document type names - Required
  docIdCard: '身份证',
  docProofOfAddress: '地址证明',
  docIncomeStatement: '收入证明',
  docTaxReturn: '纳税申报单',
  docBankStatement: '银行对账单',
  
  // Document type names - Optional
  docInsuranceInfo: '保险信息',
  docReferenceLetters: '推荐信',
  docAdditionalSupporting: '额外支持文件',
  
  // Document descriptions - Required
  descIdCard: '政府签发的带照片的身份证明',
  descProofOfAddress: '显示当前地址的水电费账单或银行对账单',
  descIncomeStatement: '最近的工资单或收入验证',
  descTaxReturn: '最新的纳税申报文件',
  descBankStatement: '最近3个月的银行对账单',
  
  // Document descriptions - Optional
  descInsuranceInfo: '当前保险单文件',
  descReferenceLetters: '个人或专业推荐信',
  descAdditionalSupporting: '任何其他相关文件',

  // Reminder feature translations
  sendReminderEmail: '发送提醒邮件',
  sendingReminder: '发送中...',
  reminderSent: '提醒已发送',
  reminderCooldown: '已于 {{date}} 发送',
  lastReminderSent: '上次提醒发送于 {{timeAgo}}',
  remindersUnavailable: '所有文档已提交',
  documentReminders: '文档提醒',
  reminderSuccess: '提醒邮件发送成功',
  missingDocuments: '缺失文档',

  // Uncategorized
  dashboard: "仪表盘",
  signedInAs: "已登录为",
  signOut: "退出登录",
  loginTitle: "登录",
  loginSubtitle: "请输入您的用户名和密码",
  username: "用户名",
  password: "密码",
  signIn: "登录",
  msftadssoBtnText: "使用微软账号登录",
  googleSignIn: "使用谷歌账号登录",
  regularUser: "普通用户",
  superUser: "超级用户",
  loginwithdemoaccounts: "使用演示账户登录",
  invalidLoginCredentials: "无效的登录凭据",
  loginError: "登录错误",
  currentDate: "当前日期",
  suggestAFeatureBtnText: "建议功能"


};

// Initialize i18next with proper configuration for handling UTF-8 characters
i18n.use(initReactI18next).init({
  resources: {
    en: { translation: enTranslations },
    es: { translation: esTranslations },
    zh: { translation: zhTranslations }
  },
  lng: language || 'en',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false
  },
  // Add these properties to ensure proper handling of non-Latin characters
  returnObjects: true,
  returnEmptyString: false,
  saveMissing: false
});

export default i18n;
